import { render, staticRenderFns } from "./YoutubeIframe.vue?vue&type=template&id=0e64b944&"
import script from "./YoutubeIframe.vue?vue&type=script&lang=js&"
export * from "./YoutubeIframe.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeIframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports